module.exports = __webpack_public_path__ + "assets/img/Blockchain.294e86f3.png";